import React, { useMemo, useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { CANCEL_PAYMENT } from "utils/mutations";
import { compose } from "redux";
import { withStyles, withBreakpoint, withMobile } from "components/common";
import Table from "components/common/Table";

const moment = require("moment");

const computeColumns = (belowMd, user) =>
  belowMd
    ? [
        {
          Header: "Payment Initiated",
          accessor: data =>
            data.created_at
              ? `${moment.unix(data.created_at / 1000).format("M/D/YYYY LT")}`
              : "unknown"
        },
        {
          Header: "Payment Settled",
          accessor: data =>
            data.settled_at
              ? `${moment.unix(data.settled_at / 1000).format("M/D/YYYY LT")}`
              : ""
        },
        {
          Header: "Amount",
          accessor: "amount"
        },
        {
          Header: "Status",
          accessor: data => data.status || "pending"
        }
      ]
    : [
        {
          Header: "Payment Created",
          accessor: data =>
            data.created_at
              ? `${moment.unix(data.created_at / 1000).format("M/D/YYYY LT")}`
              : "unknown"
        },
        {
          Header: "Payment Settled",
          accessor: data =>
            data.settled_at
              ? `${moment.unix(data.settled_at / 1000).format("M/D/YYYY LT")}`
              : ""
        },
        {
          Header: "Amount",
          accessor: "amount"
        },
        {
          Header: "Category",
          accessor: data => data.category || ""
        },
        {
          Header: "Payment Method",
          accessor: data =>
            data.payment_method ? (
              <div className="text-sm">
                <div>{data.payment_method.institution}</div>
                <div>{data.payment_method.nickname}</div>
                <div className="text-gray-700">
                  ({data.payment_method.type}) -
                  {data.payment_method.account_number_last_four}
                </div>
              </div>
            ) : (
              ""
            )
        },
        {
          Header: "Status",
          accessor: data => <StatusComponent data={data} user={user} />
        }
      ];

const triggerCancelPayment = (data, cancelPayment, callback) => {
  console.log(data);
  cancelPayment({
    variables: {
      user_id: data.email,
      id: data.id
    }
    // TODO: perform refetch
  })
    .then(async res => {
      console.log("CANCELED PAYMENT:", res);
      callback(true);
    })
    .catch(e => {
      console.log("ERROR CANCELING PAYMENT", e);
      callback(false);
    });
  return false;
};

const StatusComponent = ({ data, user }) => {
  const [cancelPayment] = useMutation(CANCEL_PAYMENT);
  const status =
    data.status === "RETURNED" || data.returned_at
      ? `${data.status === "SETTLED" ? "SETTLED (RETURNED)" : data.status} (${
          data.ach_return_code
        })`
      : data.status;
  const [statusText, setStatusText] = useState(status || "PENDING");

  const callback = result => {
    if (result) {
      setStatusText("CANCELLED");
    } else {
      setStatusText("PENDING");
    }
  };

  const cancelButton = (
    <button
      onClick={e => {
        const act = window.confirm(
          "Are you sure you want to cancel this payment?"
        );
        if (act) {
          triggerCancelPayment(
            { ...data, email: user.email },
            cancelPayment,
            callback
          );
          setStatusText("cancelling...");
        }
      }}
    >
      &nbsp;(cancel)
    </button>
  );
  return (
    <>
      <section>
        <span>{statusText}</span>
        {statusText === "PENDING" ? cancelButton : ""}
      </section>
      {(data.status === "RETURNED" || data.returned_at) && (
        <section>{`${moment
          .unix(data.returned_at / 1000)
          .format("M/D/YYYY LT")}`}</section>
      )}
    </>
  );
};

const UserPaymentsTable = ({
  user,
  payments = [],
  payment_methods = [],
  loading,
  breakpointContext: { isBelow }
}) => {
  const columns = useMemo(() => computeColumns(isBelow("md"), user), [
    isBelow("md")
  ]);
  const pms = {};
  payment_methods.forEach(pm => {
    pms[pm.id] = pm;
  });
  payments.forEach(pp => {
    // console.log(pp.payment_method_id)
    pp.payment_method = pms[pp.payment_method_id];
  });
  // console.log(payments);
  const [filteredPayments] = useState(payments);
  filteredPayments.sort(
    (a, b) => parseInt(b.created_at) - parseInt(a.created_at)
  );
  console.log(payments);
  const getRowStyle = row => {
    const getColumnColor = data => {
      switch (data.status) {
        case "PENDING":
          return "#FFE9AB";
        case "SETTLED":
          return data.returned_at ? "#F59E0B" : "#E6FFED";
        case "RETURNED":
          return "#FFA6A6";
        case "CANCELED":
          return "#DDDDDD";
      }
    };
    return {
      backgroundColor: getColumnColor(row.original)
    };
  };
  return (
    <div className="mt-5">
      <h1 className="text-2xl font-title mb-2 font-light">Payments</h1>
      <div className="my-6">
        {loading ? (
          <div>Loading...</div>
        ) : filteredPayments.length ? (
          <Table
            id="payments"
            user={user}
            data={filteredPayments}
            columns={columns}
            getRowStyle={getRowStyle}
          />
        ) : (
          <div>Currently there are no payments.</div>
        )}
      </div>
    </div>
  );
};

export default compose(
  withMobile,
  withStyles,
  withBreakpoint
)(UserPaymentsTable);
